<script lang="ts">
	import { Accordion } from '@repo/commons/components'
	import type { AccordionConfig } from '@repo/commons/models'

	interface Props {
		items: AccordionConfig[]
		searchText?: string
		class?: string
		onToggle?: (itemId: string, expanded: boolean) => void
		onHighlightMatch?: (id: string, match: string, isExactMatch: boolean) => void
	}

	let {
		items = $bindable([]),
		searchText = '',
		class: className = '',
		onToggle,
		onHighlightMatch
	}: Props = $props()
</script>

<div class={className}>
	{#each items as item (item.id)}
		<Accordion
			title={item.title}
			expanded={item.expanded}
			disabled={item.disabled}
			{searchText}
			onToggle={(expanded) => onToggle?.(item.id, expanded)}
			onHighlightMatch={(match, isExactMatch) => onHighlightMatch?.(item.id, match, isExactMatch)}
		>
			{#if item.component}
				{#if typeof item.component === 'string'}
					{@html item.component}
				{:else}
					<item.component {...item.props || {}} />
				{/if}
			{:else}
				<slot name="item-content" {item} />
			{/if}
		</Accordion>
	{/each}
</div>
